<template>
    <div v-if="page_loading">
        <loading :page_loading="page_loading" />
    </div>
    <div v-else-if="order_master == null">
        <v-row justify="center" class="mb-12">
            <v-col cols="12" sm="10" md="8" class="pa-0" align="center">
                <h1 class="ml-2 mb-4">ไม่พบใบสั่งซื้อ</h1>
            </v-col>
        </v-row>
    </div>
    <div v-else>
        <loading :loading="loading" />

        <v-row justify="center" class="mb-12">
            <v-col cols="12" sm="10" md="8" class="pa-0">
                <h1 class="ml-2 mb-4">ใบสั่งซื้อ {{ format_order_id(this.order_master.ID) }}</h1>
                <div class="separator"></div>
            </v-col>
        </v-row>

        <v-row justify="center" class="mb-12">
            <v-col cols="12" sm="10" md="8" class="pa-0">
                <h2 class="ml-2 mb-2">สินค้า</h2>
                <v-card tile class="pa-4">
                    <v-row v-for="(item, index) in product_list" :key="index">
                        <v-col cols="2">
                            <div v-if="item.PhotoLink != null || item.PhotoLink != ''">
                                <img :src="item.PhotoLink" width="50"  @click="photo_click(item.PhotoLink)">
                            </div>
                        </v-col>
                        <v-col cols="10">
                            <v-row>
                                <v-col cols="4" class="py-0">
                                    <div>
                                        {{ item.Name }}
                                    </div>
                                </v-col>
                                <v-col cols="3" class="py-0" align="right">
                                    <div class="hidden-xs-only">
                                        จำนวน {{ item.Quantity }} ชิ้น
                                    </div>
                                    <div class="hidden-sm-and-up">
                                        x{{ item.Quantity }}
                                    </div>
                                </v-col>
                                <v-col v-if="item.UnitPrice != null" cols="5" class="py-0" align="right">
                                    <div class="hidden-xs-only">
                                        ราคา {{ format_price(item.Quantity * item.UnitPrice) }} บาท
                                    </div>
                                    <div class="hidden-sm-and-up">
                                        <div>
                                            {{ format_price(item.Quantity * item.UnitPrice) }}
                                        </div>
                                        <div>
                                            บาท
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-card v-if="order_master.IsCOD == 0" tile elevation="0" color="blue-grey lighten-4" class="my-3 px-3">
                        <v-row>
                            <v-col align="right">
                                ราคาทั้งหมด
                            </v-col>
                            <v-col cols="8" md="3" align="right">
                                {{ format_price(order_master.TotalPrice) }} บาท
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col align="right" class="py-0">
                                ค่าจัดส่ง
                            </v-col>
                            <v-col cols="8" md="3" align="right" class="py-0">
                                {{ format_price(order_master.DeliveryCost) }} บาท
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col align="right">
                                รวม
                            </v-col>
                            <v-col cols="8" md="3" align="right">
                                <h3>
                                    <font v-if="order_master.DeliveryCost == null" color="green">{{ order_master.TotalPrice }} บาท</font>
                                    <font v-else color="green">{{ format_price(Number(order_master.DeliveryCost) + Number(order_master.TotalPrice)) }} บาท</font>
                                </h3>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="order_master.IsCOD == 0" justify="center" class="mb-12">
            <v-col cols="12" sm="10" md="8" class="pa-0">
                <h2 class="ml-2 mb-2">ชำระเงิน</h2>
                <v-card tile class="pa-4">
                    <div v-if="customer_transfer_item.BankID != null">
                        <v-row>
                            <v-col>
                                <h3>{{ customer_transfer_item.BankFullText }}</h3>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" md="3" lg="2">
                                <font class="font-weight-bold">เวลาที่โอน : </font>
                            </v-col>
                            <v-col cols="8" md="4">
                                {{ customer_transfer_item.CreatedDatetime }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" md="3" lg="2">
                                <font class="font-weight-bold">เวลาแจ้งโอน : </font>
                            </v-col>
                            <v-col cols="8" md="4">
                                {{ customer_transfer_item.InformDatetime }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" md="3" lg="2">
                                <font class="font-weight-bold">จำนวนเงิน : </font>
                            </v-col>
                            <v-col cols="8" md="4">
                                {{ format_price(customer_transfer_item.Amount) }}
                            </v-col>
                        </v-row>
                        <v-row v-if="customer_transfer_item.PhotoLink != null">
                            <v-col cols="4" md="3" lg="2">
                                <font class="font-weight-bold">สลิป : </font>
                            </v-col>
                            <v-col cols="8" md="4">
                                <img
                                    :src="customer_transfer_item.PhotoLink"
                                    width="200px"
                                    @click="photo_click(customer_transfer_item.PhotoLink)
                                ">
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <v-row>
                            <v-col>
                                <v-radio-group v-model="rd_group_bank_account">
                                    <v-radio
                                        v-for="(item, index) in rd_bank_account_list"
                                        :key="item.ID"
                                        :label="item.Name"
                                        :value="index"
                                        return-object
                                    ></v-radio>
                                </v-radio-group>
                                <v-btn
                                    color="info"
                                    :disabled="is_bt_transfer"
                                    @click="bt_transfer_click('desktop')"
                                    class="hidden-xs-only"
                                >แจ้งโอนเงิน</v-btn>
                                <v-btn
                                    color="info"
                                    :disabled="is_bt_transfer"
                                    @click="bt_transfer_click('mobile')"
                                    class="hidden-sm-and-up"
                                >แจ้งโอนเงิน</v-btn>
                                <v-dialog v-model="dialog_transfer" :fullscreen="is_dialog_fullscreen" scrollable persistent max-width="500px">
                                    <v-card>
                                        <v-card-title>
                                            แจ้งโอนเงิน
                                            <v-spacer />
                                            <v-btn icon @click="dialog_transfer = false"><v-icon>mdi-close</v-icon></v-btn>
                                        </v-card-title>
                                        <v-divider />
                                        <v-card-text class="pt-5">
                                            <h3 v-if="rd_group_bank_account != null" class="mb-4">{{ rd_bank_account_list[rd_group_bank_account].Name }}</h3>
                                            <v-file-input
                                                v-model="input_file_upload"
                                                label="แนบสลิป"
                                                outlined
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-file-image"
                                                placeholder="แนบสลิปที่นี่"
                                            >
                                                <template v-slot:selection="{ text }">
                                                    <v-chip
                                                        small
                                                        label
                                                        color="primary"
                                                    >
                                                        {{ text }}
                                                    </v-chip>
                                                </template>
                                            </v-file-input>
                                            <v-text-field
                                                :value="input_transfer_amount"
                                                @change="value => input_transfer_amount = value"
                                                type="number"
                                                label="จำนวนเงินที่โอน"
                                                outlined
                                                autocomplete="off"
                                            ></v-text-field>
                                            <v-menu
                                                :value="menu_transfer_date"
                                                @change="value => menu_transfer_date = value"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        :value="computed_transfer_date"
                                                        @change="value => computed_transfer_date = value"
                                                        label="วันที่โอน"
                                                        outlined
                                                        prepend-icon=""
                                                        prepend-inner-icon="mdi-calendar"
                                                        readonly
                                                        v-on="on"
                                                        autocomplete="off"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="date_transfer"
                                                    no-title
                                                    :allowed-dates="val => val <= new Date().toISOString().substr(0, 10)"
                                                    @input="menu_transfer_date = false"
                                                ></v-date-picker>
                                            </v-menu>
                                            <v-row>
                                                <v-col sm="3" class="py-0">
                                                    <v-select
                                                        v-model="select_hour"
                                                        :items="select_hour_items"
                                                        label="ชั่วโมง"
                                                        outlined
                                                    ></v-select>
                                                </v-col>
                                                <div class="pt-2">:</div>
                                                <v-col sm="3" class="py-0">
                                                    <v-select
                                                        v-model="select_minute"
                                                        :items="select_minute_items"
                                                        label="นาที"
                                                        outlined
                                                    ></v-select>
                                                </v-col>
                                            </v-row>

                                            <div v-if="shipping_address == null && order_master.ExpressCompanyID != 0" class="mt-8">
                                                <h3 class="mb-4">ชื่อ - ที่อยู่ในการจัดส่ง</h3>
                                                <v-form
                                                    ref="shipping_address_form"
                                                    v-model="shipping_address_valid"
                                                    lazy-validation
                                                >
                                                    <v-text-field
                                                        :value="input_shipping_name"
                                                        @change="value => input_shipping_name = value"
                                                        label="ชื่อ - นามสกุล"
                                                        outlined
                                                        :rules="[ v => !!v || 'กรุณาระบุ', ]"
                                                        required
                                                        autocomplete="off"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        :value="input_shipping_phone"
                                                        @change="value => input_shipping_phone = value"
                                                        type="number"
                                                        label="เบอร์โทร"
                                                        outlined
                                                        :rules="[ v => !!v || 'กรุณาระบุ', v => v.length == 9 || v.length == 10 || 'กรุณาใส่เบอร์โทรศัพท์ให้ถูกต้อง ex: 0812345678' ]"
                                                        required
                                                        autocomplete="off"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        :value="input_shipping_address"
                                                        @change="value => input_shipping_address = value"
                                                        label="ที่อยู่"
                                                        outlined
                                                        :rules="[ v => !!v || 'กรุณาระบุ', ]"
                                                        required
                                                        autocomplete="off"
                                                    ></v-text-field>
                                                    <v-autocomplete
                                                        v-model="select_shipping_postcode_mapping"
                                                        :items="postcode_mapping"
                                                        :item-text="item => item.zipcode + ' ' + item.province + ' ' + item.amphoe + ' ' + item.district"
                                                        item-value="id"
                                                        label="รหัสไปรษณีย์ / จังหวัด / (เขต/อำเภอ) / (แขวง/ตำบล)"
                                                        outlined
                                                        dense
                                                        :rules="[ v => !!v || 'กรุณาระบุ', ]"
                                                        required
                                                        return-object
                                                        autocomplete="off"
                                                    ></v-autocomplete>
                                                </v-form>
                                            </div>
                                        </v-card-text>
                                        <v-divider />
                                        <v-card-actions>
                                            <v-row justify="center">
                                                <v-btn
                                                    color="info"
                                                    :disabled="!shipping_address_valid"
                                                    :loading="bt_loading"
                                                    @click="bt_transfer_submit()"
                                                >แจ้งชำระเงิน</v-btn>
                                            </v-row>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="shipping_address != null" justify="center" class="mb-12">
            <v-col cols="12" sm="10" md="8" class="pa-0">
                <h2 class="ml-2 mb-2">
                    ที่อยู่
                    <v-btn
                        v-if="order_master.IsCOD == 0 && (order_master.OrderStatusNameEng == 'OpenOrder' || order_master.OrderStatusNameEng == 'WaitCheck' || order_master.OrderStatusNameEng == 'WaitPack' )"
                        icon
                        class="ml-2 hidden-xs-only"
                        @click="bt_edit_address_click('desktop')"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="order_master.IsCOD == 0 && (order_master.OrderStatusNameEng == 'OpenOrder' || order_master.OrderStatusNameEng == 'WaitCheck' || order_master.OrderStatusNameEng == 'WaitPack' )"
                        icon
                        class="ml-2 hidden-sm-and-up"
                        @click="bt_edit_address_click('mobile')"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-dialog v-model="dialog_edit_address" :fullscreen="is_dialog_fullscreen" scrollable persistent max-width="500px">
                        <v-card>
                            <v-card-title>
                                ที่อยู่
                                <v-spacer />
                                <v-btn icon @click="dialog_edit_address = false"><v-icon>mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-divider />
                            <v-card-text class="pt-5">
                                <h3 class="mb-4">ชื่อ - ที่อยู่ในการจัดส่ง</h3>
                                <v-form
                                    ref="shipping_address_form"
                                    v-model="shipping_address_valid"
                                    lazy-validation
                                >
                                    <v-text-field
                                        :value="input_shipping_name"
                                        @change="value => input_shipping_name = value"
                                        label="ชื่อ - นามสกุล"
                                        outlined
                                        :rules="[ v => !!v || 'กรุณาระบุ', ]"
                                        required
                                        autocomplete="off"
                                    ></v-text-field>
                                    <v-text-field
                                        :value="input_shipping_phone"
                                        @change="value => input_shipping_phone = value"
                                        type="number"
                                        label="เบอร์โทร"
                                        outlined
                                        :rules="[ v => !!v || 'กรุณาระบุ', v => v.length == 10 || 'กรุณาใส่เบอร์โทรศัพท์ให้ถูกต้อง ex: 0812345678' ]"
                                        required
                                        autocomplete="off"
                                    ></v-text-field>
                                    <v-text-field
                                        :value="input_shipping_address"
                                        @change="value => input_shipping_address = value"
                                        label="ที่อยู่"
                                        outlined
                                        :rules="[ v => !!v || 'กรุณาระบุ', ]"
                                        required
                                        autocomplete="off"
                                    ></v-text-field>
                                    <v-autocomplete
                                        :value="select_shipping_postcode_mapping"
                                        @change="value => select_shipping_postcode_mapping = value"
                                        :items="postcode_mapping"
                                        :item-text="item => item.zipcode + ' ' + item.province + ' ' + item.amphoe + ' ' + item.district"
                                        label="รหัสไปรษณีย์ / จังหวัด / (เขต/อำเภอ) / (แขวง/ตำบล)"
                                        outlined
                                        dense
                                        :rules="[ v => !!v || 'กรุณาระบุ', ]"
                                        required
                                        return-object
                                        autocomplete="off"
                                    ></v-autocomplete>
                                </v-form>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-row justify="center">
                                    <v-btn color="info" text :disabled="!shipping_address_valid" :loading="bt_loading" @click="bt_edit_address_submit()">ยืนยัน</v-btn>
                                </v-row>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </h2>
                <v-card tile class="pa-4">
                    <v-row>
                        <v-col cols="4" md="3">
                            <font class="font-weight-bold">ชื่อ : </font>
                        </v-col>
                        <v-col cols="8" md="4">
                            {{ shipping_address.Name }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" md="3">
                            <font class="font-weight-bold">เบอร์โทร : </font>
                        </v-col>
                        <v-col cols="8">
                            {{ shipping_address.Phone }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4" md="3">
                            <font class="font-weight-bold">ที่อยู่จัดส่ง : </font>
                        </v-col>
                        <v-col cols="8">
                            {{ shipping_address.AddressFullText }}
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center" class="mb-12">
            <v-col cols="12" sm="10" md="8" class="pa-0">
                <h2 class="ml-2 mb-2">
                    รูปแบบพัสดุ
                </h2>
                <v-card tile class="pa-4">
                    <v-row>
                        <v-col cols="4" md="3">
                            <font class="font-weight-bold">รูปแบบ : </font>
                        </v-col>
                        <v-col cols="8" md="4">
                            {{ (order_master.IsCOD == 0) ? 'ธรรมดา' : 'COD' }}
                        </v-col>
                    </v-row>
                    <v-row v-if="order_master.IsCOD == 1">
                        <v-col cols="4" md="3">
                            <font class="font-weight-bold">ราคา : </font>
                        </v-col>
                        <v-col cols="8" md="4">
                            {{ format_price(order_master.CODAmount) }} บาท
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center" class="mb-12">
            <v-col cols="12" sm="10" md="8" class="pa-0">
                <h2 class="ml-2 mb-2">สถานะออเดอร์</h2>
                <v-card tile class="pa-4">
                    <v-row v-for="(item, index) in order_status_list" :key="index">
                        <v-col cols="4" md="3">
                            {{ item.UpdatedDatetime }}
                        </v-col>
                        <v-col cols="8">
                            {{ item.Name }}
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="order_master.TrackingNo != null || express_company_item.ID == 0" justify="center">
            <v-col cols="12" sm="10" md="8" class="pa-0">
                <h2 class="ml-2 mb-2">สถานะการจัดส่ง</h2>
                <v-card class="pa-6">
                    <div v-if="express_company_item.ID == 0">
                        {{ express_company_item["Name"] }}
                    </div>
                    <div v-else>
                        <div v-if="express_company_item.ID == 1">
                            <v-img class="bex48-logo" src="data:image/png;base64,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"></v-img>
                        </div>
                        <div align="center">
                            <h3 v-if="express_company_item.ID == 1">800 best express</h3>
                            <h3 v-else>{{ express_company_item["Name"] }}</h3>
                        </div>
                        <div align="center" class="mt-3">
                            <h2>{{ order_master.TrackingNo }}</h2>
                            <div class="pb-2" />
                            <div v-if="statusExpress!=null && statusExpress.status.length>0">
                              <div v-for="(item, index) in statusExpress.status" :key="index">
                                <span> {{formatDatetime(item.date) +" "+ item.description}} </span>
                              </div>
                            </div>
                        </div>
                        <v-row v-for="(item, index) in shipping_status_list" :key="index" class="mt-6">
                            <v-col cols="4" md="2">
                                {{ item.acceptTime }}
                            </v-col>
                            <v-col cols="8" md="6">
                                {{ item.remark }}
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog_photo" scrollable persistent max-width="1000px">
            <v-card>
                <v-card-title>
                    สลิป
                    <v-spacer />
                    <v-btn icon color="info" @click="dialog_photo = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-col cols="12" align="center">
                        <img :src="photo_link">
                    </v-col>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Loading from '@/website/components/Loading'
import axios from 'axios'
import { header_token } from '@/website/token'
import { format_order_id, format_price, formatDatetime } from '@/website/global_function'
import { customerOverviewService, postcodeMappingService, orderService_dotnet } from '@/website/global'
import { OrderStatusDict } from '@/website/statusDict'
export default {
    components: {
        Loading
    },

    data: () => ({
        // System
        page_loading: true,
        loading: false,
        is_dialog_fullscreen: false,
        bt_loading: false,
        dialog_photo: false,
        photo_link: null,
        // Data
        order_master_token: null,
        order_master: null,
        product_list: null,
        // ชำระเงิน
        customer_transfer_item: null,
        rd_group_bank_account: null,
        rd_bank_account_list: null,
        is_bt_transfer: true,
        dialog_transfer: false,
        input_file_upload: null,
        input_transfer_amount: null,
        menu_transfer_date: false,
        date_transfer: new Date().toISOString().substr(0, 10),
        select_hour: null,
        select_hour_items: [
            '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
            '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'
        ],
        select_minute: null,
        select_minute_items: [
            '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
            '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
            '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
            '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
            '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
            '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'
        ],
        shipping_address_valid: true,
        input_shipping_name: null,
        input_shipping_phone: '',
        input_shipping_address: null,
        postcode_mapping: null,
        select_shipping_postcode_mapping: null,
        // ที่อยู่
        dialog_edit_address: false,
        shipping_address: null,
        // สถานะออเดอร์
        order_status_list: null,
        // สถานะการจัดส่ง
        express_company_item: null,
        shipping_status_list: null,

        // param token and ref
        order_detail_token: null,
        order_detail_ref: null,

        // เรียกข้อมูล order
        order: null,
        datapay: [],
        orderStatusHistory: [],
        orderPack: [],
        statusExpress: null,
    }),

    async created() {
        this.order_master_token = this.$route.params.token

        this.order_detail_ref = this.$route.query.ref
        this.order_detail_token = this.$route.query.token
        await this.get_postcode_mapping()

        if(typeof(this.order_detail_ref) ==='undefined'){
          this.order_detail_ref = null
        } else if (typeof(this.order_detail_token) ==='undefined') {
          this.order_detail_token = null
        }
        await this.load_data()
        if (this.order_master != null) {
            document.title = 'ออเดอร์ : ' + this.format_order_id(this.order_master.ID) + ' เช็ตสถานะใบสั่งซื้อ'
        } else {
            document.title = "PACKHAI ไม่พบใบสั่งซื้อ"
        }

        // เรียกข้อมูล order
        this.ShowOrderDetail()

        this.page_loading = false
    },

    watch: {
        rd_group_bank_account() {
            if (this.rd_group_bank_account != null) {
                this.is_bt_transfer = false
            }
        },
    },

    computed: {
        computed_transfer_date() {
            return this.formatDate(this.date_transfer)
        },
    },

    methods: {
      async ShowOrderDetail(){
        let response = await axios.post(orderService_dotnet+'Order/show-order-detail', {
          'orderToken': this.order_detail_token,
        }, {headers: header_token})
        if (response.status==200){
          this.order = response.data.vOrderMaster
          this.orderStatusHistory = response.data.orderStatusHistory
          this.orderPack = response.data.orderPack
          this.datapay = response.data.orderPay
          this.statusExpress = response.data.statusExpress
        }
      },

      formatDatetime,
        format_order_id,
        format_price,

        async get_postcode_mapping () {
          let response = await axios.post(postcodeMappingService+'postcodeMapping/get_postcodeMapping', {})
          if (response.data.status == 'success') {
            this.postcode_mapping = response.data.data
          }
        },

        bt_edit_address_click(site) {
            this.input_shipping_name = this.shipping_address.Name
            this.input_shipping_phone = this.shipping_address.Phone
            this.input_shipping_address = this.shipping_address.Address
            this.select_shipping_postcode_mapping  = {
                'id': this.shipping_address.PostcodeMappingID,
                'district': this.shipping_address.Tumbon,
                'amphoe': this.shipping_address.Amphoe,
                'province': this.shipping_address.Province,
                'zipcode': this.shipping_address.Postcode,
            }
            if (site == 'desktop') {
                this.is_dialog_fullscreen = false
            } else {
                this.is_dialog_fullscreen = true
            }
            this.dialog_edit_address = true
        },

        async bt_edit_address_submit() {
            if (this.$refs.shipping_address_form.validate()) {
                this.snackbar = true
                this.bt_loading = true
                let response = await axios.post(customerOverviewService+'purchase_order/bt_edit_address_submit', {
                    'shop_id': this.order_master.ShopID,
                    'shipping_address_id': this.shipping_address.ID,
                    'name': this.input_shipping_name,
                    'phone': this.input_shipping_phone,
                    'address': this.input_shipping_address,
                    'postcode_mapping': this.select_shipping_postcode_mapping
                })
                if (response.data.status == 'success') {
                    this.dialog_edit_address = false
                    this.bt_loading = false
                    this.page_loading = true
                    await this.load_data()
                    this.page_loading = false
                }
            }
        },

        bt_transfer_click(site) {
            this.input_transfer_amount = Number(this.order_master.DeliveryCost) + Number(this.order_master.TotalPrice)
            this.input_transfer_amount = Number(this.input_transfer_amount).toFixed(2)
            this.select_hour = new Date().toTimeString().substring(0, 2)
            this.select_minute = new Date().toTimeString().substring(3, 5)
            if (site == 'desktop') {
                this.is_dialog_fullscreen = false
            } else {
                this.is_dialog_fullscreen = true
            }
            this.dialog_transfer = true
        },

        async bt_transfer_submit() {
            this.bt_loading = true
            const form_data = new FormData()
            let response
            form_data.append('order_master_id', this.order_master.ID)
            form_data.append('shop_id', this.order_master.ShopID)
            form_data.append('order_status_id', OrderStatusDict.WaitCheck)
            form_data.append('shop_bank_account_id', this.rd_bank_account_list[this.rd_group_bank_account].ID)
            form_data.append('file_upload', this.input_file_upload)
            if ((this.input_transfer_amount != '') && (this.input_transfer_amount != null)) {
                form_data.append('amount',  this.input_transfer_amount)
            }
            form_data.append('inform_date', this.date_transfer + " " + this.select_hour + ":" + this.select_minute)
            if (this.shipping_address == null && this.order_master.ExpressCompanyID != 0) {
                if (this.$refs.shipping_address_form.validate()) {
                    this.snackbar = true
                    var shipping_address_item = {
                        'Name': this.input_shipping_name,
                        'Phone': this.input_shipping_phone,
                        'Address': this.input_shipping_address,
                        'PostcodeMappingID': this.select_shipping_postcode_mapping.id,
                        'Tumbon': this.select_shipping_postcode_mapping.district,
                        'Amphoe': this.select_shipping_postcode_mapping.amphoe,
                        'Province': this.select_shipping_postcode_mapping.province,
                        'Postcode': this.select_shipping_postcode_mapping.zipcode
                    }
                    form_data.append('shipping_address_item', JSON.stringify(shipping_address_item))
                    response = await axios.post(customerOverviewService+'purchase_order/bt_transfer_submit', form_data)
                }
            } else {
                response = await axios.post(customerOverviewService+'purchase_order/bt_transfer_submit', form_data)
            }
            if (response != null) {
                if (response.data.status == 'success') {
                    this.dialog_transfer = false
                    this.page_loading = true
                    await this.load_data()
                    this.page_loading = false
                }
            }
            this.bt_loading = false
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}-${month}-${year}`
        },

        async load_data() {
            let response = await axios.post(customerOverviewService+'purchase_order/load_data_detail_order', {
                'token': this.order_detail_token,
                'ref': this.order_detail_ref
            })

            var res = response.data
            var status = res.Status

            if (status) {
                this.order_master = res.order_master

                if (this.order_master != null) {
                    this.product_list = res.product_list
                    this.customer_transfer_item = res.customer_transfer_item
                    this.rd_bank_account_list = res.bank_account_list
                    this.shipping_address = res.shipping_address
                    this.order_status_list = res.order_status_list
                    this.express_company_item = res.ExpressCompanyItem
                    this.shipping_status_list = res.shipping_status_list
                }
            }
        },


        photo_click(url) {
            this.photo_link = url
            this.dialog_photo = true
        }
    }
}
</script>

<style scoped>
    /* >>>.v-dialog {
        -webkit-box-shadow: none;
        box-shadow: none;
    } */

    >>>.bex48-logo {
        width: 12.533vw;
        height: 11.2vw;
        display: block;
        /* margin: 8.8vw auto 1.6vw; */
        margin: 1.6vw auto 1.6vw;
    }
</style>
